import React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const NumberFormatNumeric = React.forwardRef(function NumberFormatNumeric(
  props,
  ref
) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref || inputRef}
      allowNegative={false}
      valueIsNumericString
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      isAllowed={({ value }) => {
        if (value !== "" && (props?.min || props?.max)) {
          const regex = /^[0-9]*$/;

          if (!regex.test(value)) {
            return false;
          }
          const val = Number(value);
          return (props?.min && props?.max) ? val >= props?.min && val <= props?.max : val >= props?.min || val <= props?.max;
        }

        return true;
      }}
    />
  );
});

NumberFormatNumeric.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default NumberFormatNumeric;